import globalConfig, {
  chinaAppName,
} from "@/config/config.js";

export const validateYoutubeLink = (input) => {
  let regex = null;
  if (globalConfig.appname === chinaAppName) {
    if (input.length <= 500 && input.length >= 10) {
      regex = /(https:\/\/)|(http:\/\/)/
      return regex.test(input);
    } else {
      return false;
    }
  } else {
    if (input.length <= 150 && input.length >= 20) {
      regex =
        /^(https:\/\/www\.youtube\.com\/watch\?v=.*)|(https:\/\/youtu\.be\/.*)|(https:\/\/www\.youtube\.com\/shorts\/.*)|(https:\/\/youtube\.com\/shorts\/.*)|(https:\/\/m\.youtube\.com\/watch\?v=.*)|(https:\/\/m\.youtube\.com\/shorts\/.*)$/;
      return regex.test(input);
    } else {
      return false;
    }
  }
};





const containsEmoji = (str) => {
  // \u{1F600}-\u{1F64F}：表情符号
  // \u{1F300}-\u{1F5FF}：杂项符号和象形文字
  // \u{1F680}-\u{1F6FF}：交通和地图符号
  // \u{1F700}-\u{1F77F}：阿卢雷特文、符号和象形文字
  // \u{1F780}-\u{1F7FF}：几何形状扩展
  // \u{1F800}-\u{1F8FF}：补充箭头
  // \u{1F900}-\u{1F9FF}：补充符号和象形文字
  // \u{1FA00}-\u{1FA6F}：象棋、日本和韩国的象形文字
  // \u{1FA70}-\u{1FAFF}：其他象形文字
  // \u{2700}-\u{27BF}：杂项符号
  // \uFE00}-\u{FE0F}：变异选择器
  // \u200D：零宽度连接符，用于Emoji的组合
  // \u20E3：组合使用标志
  // \uD83C[\uDC00-\uDFFF]：旗帜和表情符号的一部分
  // \ud83d[\udc00-\ude4f]：表情符号的范围
  var emojiRegex =
    /([\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2700}-\u{27BF}\u{FE00}-\u{FE0F}\u{200D}\u{20E3}]|\uD83C[\uDC00-\uDFFF]|\ud83d[\udc00-\ude4f])+/gu;
  return emojiRegex.test(str);
};

const isAllPunctuation = (str) => {
  var punctuationRegex = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;
  return punctuationRegex.test(str);
};

export default {
  validateYoutubeLink,
  containsEmoji,
  isAllPunctuation
};
